import hooverLogo from "../assests/images/Hoover-logo.PNG";
import dunloopLogo from "../assests/images/Logo-dunlop.png";
import taurusLogo from "../assests/images/logo-Taurus.jpg";
import asimcoLogo from "../assests/images/ASIMCO-logo-whiteBG.png";
export { hooverLogo, dunloopLogo, taurusLogo, asimcoLogo };

export const logos = [hooverLogo, dunloopLogo, taurusLogo, asimcoLogo];

export const WarrantyLogos = [hooverLogo, taurusLogo];
